<mat-expansion-panel class="collapsible-panel">
  <mat-expansion-panel-header>
    <div class="w-100 d-flex justify-space-between align-center">
      <div class="collapsible__title h6  mb-0" app-click-stop-propagation>
        <ng-content select="[title]"></ng-content>
      </div>
      <div class="mr-6">
        <ng-content select="[desc]"></ng-content>
      </div>
    </div>
  </mat-expansion-panel-header>

  <div class="mb-4 row gx-lg">
    <mat-divider class="pos-static"></mat-divider>
  </div>

  <div class="collapsible__body">
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
<mat-divider></mat-divider>
